// COMPONENTS
import axios from "../components/helpers/axios";
import Wrapper from "../components/helpers/Wrapper";

// CHARTS

import GroupAndSortedColumns from "../components/ui/charts/GroupAndSortedColumns";
import VerticalLineChart from "../components/ui/charts/VerticalLineChart";
import WaterFallChart from "../components/ui/charts/WaterFallChart";
import HeatRiskGrowth from "../components/ui/charts/HeatRiskGrowth";
import HorizontalClusteredBarChart from "../components/ui/charts/HorizontalClusteredBarChart";
import BarChart from "../components/ui/charts/BarChart";
import CustomBarChart from "../components/ui/charts/CustomBarChart";
import GroupedBarChart from "../components/ui/charts/GroupedBarChart";
import { add } from "@amcharts/amcharts5/.internal/core/util/Time";

const DashboardTest = ({ topCardData }) => {

  let rawDataGroupAndSortedColumns = {
    "KSA1": {
      "UAE": {
        "MAT 2Y": 10,
        "MAT 1Y": 35,
        "MAT Y": 5
      },
      "MAT 2Y": 10,
      "MAT 1Y": 35,
      "MAT Y": 5
    }
    ,
    "KSA2": {
      "MAT 2Y": 10,
      "MAT 1Y": 35,
      "MAT Y": 5
    }

  };


  const yAxisLabels = {
    label: 'Products',
    values: ['Hair Conditioner', 'Shampoo', 'Soap', 'Lotion', 'Perfume', 'Toothpaste', 'Deodorant', 'Face Cream'],
  };

  const xAxisLabels = {
    label: 'Companies',
    values: ['Company B', 'Company C', 'Company D', 'Company A',],
  };

  const HeatMapdata = [
    {
      "y": "Hair Conditioner",
      "x": "Company A",
      "value": 3.86
    },
    {
      "y": "Hair Conditioner",
      "x": "Company B",
      "value": -6.38
    },
    {
      "y": "Hair Conditioner",
      "x": "Company C",
      "value": 25.53
    },
    {
      "y": "Hair Conditioner",
      "x": "Company D",
      "value": 6.64
    },
    {
      "y": "Shampoo",
      "x": "Company A",
      "value": 29.15
    },
    {
      "y": "Shampoo",
      "x": "Company B",
      "value": null
    },
    {
      "y": "Shampoo",
      "x": "Company C",
      "value": 9.29
    },
    {
      "y": "Shampoo",
      "x": "Company D",
      "value": 1.87
    },
    {
      "y": "Soap",
      "x": "Company A",
      "value": 18.59
    },
    {
      "y": "Soap",
      "x": "Company B",
      "value": 36.23
    },
    {
      "y": "Soap",
      "x": "Company C",
      "value": 36.16
    },
    {
      "y": "Soap",
      "x": "Company D",
      "value": 22.02
    },
    {
      "y": "Lotion",
      "x": "Company A",
      "value": 0.05
    },
    {
      "y": "Lotion",
      "x": "Company B",
      "value": 38.76
    },
    {
      "y": "Lotion",
      "x": "Company C",
      "value": 8.6
    },
    {
      "y": "Lotion",
      "x": "Company D",
      "value": -8.09
    },
    {
      "y": "Perfume",
      "x": "Company A",
      "value": null
    },
    {
      "y": "Perfume",
      "x": "Company B",
      "value": 17.97
    },
    {
      "y": "Perfume",
      "x": "Company C",
      "value": null
    },
    {
      "y": "Perfume",
      "x": "Company D",
      "value": 6.05
    },
    {
      "y": "Toothpaste",
      "x": "Company A",
      "value": 34.67
    },
    {
      "y": "Toothpaste",
      "x": "Company B",
      "value": 23.91
    },
    {
      "y": "Toothpaste",
      "x": "Company C",
      "value": -1.52
    },
    {
      "y": "Toothpaste",
      "x": "Company D",
      "value": -5.71
    },
    {
      "y": "Deodorant",
      "x": "Company A",
      "value": null
    },
    {
      "y": "Deodorant",
      "x": "Company B",
      "value": 12.46
    },
    {
      "y": "Deodorant",
      "x": "Company C",
      "value": 38.22
    },
    {
      "y": "Deodorant",
      "x": "Company D",
      "value": 20.89
    },
    {
      "y": "Face Cream",
      "x": "Company A",
      "value": 22.35
    },
    {
      "y": "Face Cream",
      "x": "Company B",
      "value": -1.95
    },
    {
      "y": "Face Cream",
      "x": "Company C",
      "value": 13.54
    },
    {
      "y": "Face Cream",
      "x": "Company D",
      "value": 30.51
    }
  ]


  // const formattedData = daburSampleData.map(({ month_number, ...rest }) => ({ label: month_number, ...rest }))
  // setsomeRandomMap(formattedData)




  return (
    // <Wrapper>
    //   <div className="content">
    //     <div className="content_section">



    //       <div className="page_content">

    //         <div className="grid_margin_bottom">
    //           <CheckBoxDatatable
    //             tableID={'new-table'}
    //             tableTitle={'Limited Columns'}
    //             tableData={TableSampleData ?? []}
    //             dynamicColumns={true}
    //             checkbox={true}
    //             onCheckboxClickHandler={() => console.log('hii')}
    //             tableHeader={TableHeaders}
    //             tableLength={2}
    //             isFooterShow={true}
    //             hasTableLenghtDropdown={true}
    //             searchPlaceHolder={"Search Age"}
    //           />
    //         </div>


    //         <div className="section_card section_dropdown_header">
    //           <div className="grid grid_cols_1">
    //             <div className="section_card_header">
    //               <h2 className="section_card_title">Raw Data Demo Charts</h2>
    //             </div>
    //           </div>
    //         </div>

    //         <div className="grid grid_cols_4 fullpage_section_card section_card grid_margin_bottom">
    //           <div className="section_card_body">
    //             <div id={"chart" + Math.random()}>
    //               <div className="grid  section_card">
    //                 <div className="section_card_header">
    //                   <div className="section_info">
    //                     <h2 className="section_card_title">LineChart</h2>
    //                   </div>
    //                 </div>
    //                 <div className="grid grid_cols_1 section_card_body">
    //                   <div className="section_card_chart_wrapper">
    //                     {lineChart}
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>

    //         <div className="grid grid_cols_4 fullpage_section_card section_card grid_margin_bottom">
    //           <div className="section_card_body">
    //             <div id={"chart" + Math.random()}>
    //               <div className="grid  section_card">
    //                 <div className="section_card_header">
    //                   <div className="section_info">
    //                     <h2 className="section_card_title">BarChart</h2>
    //                   </div>
    //                 </div>
    //                 <div className="grid grid_cols_1 section_card_body">
    //                   <div className="section_card_chart_wrapper">
    //                     <ErrorBoundary chartType="barChartType">


    //                       <BarChart
    //                         chartClass="section_card_chart"
    //                         chartData={barData}
    //                         chartId={"chart" + Math.random()}
    //                         chartLabels={barLabel}
    //                         showLegend={true}
    //                         chartColorSet={BlueColorStart500}
    //                         showLabels={true}
    //                         minimumGridDistance={0}
    //                         percentageTooltip={true}
    //                       />
    //                     </ErrorBoundary>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>

    //         <div className="grid grid_cols_4 fullpage_section_card section_card grid_margin_bottom">
    //           <div className="section_card_body">
    //             <div id={"chart" + Math.random()}>
    //               <div className="grid  section_card">
    //                 <div className="section_card_header">
    //                   <div className="section_info">
    //                     <h2 className="section_card_title">Pie of Pie</h2>
    //                   </div>
    //                 </div>
    //                 <div className="grid grid_cols_1 section_card_body">
    //                   <div className="section_card_chart_wrapper">
    //                     {pieOfPieChart}
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>

    //       </div></div></div>
    // </Wrapper>
    <Wrapper>

      <GroupAndSortedColumns
        chartId="chart"
        chartClass="columnChart"
      // chartData={data.chartData}
      // groups={data.groups}
      />
      <VerticalLineChart
        chartId="myChart"
        chartLabels={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
        chartData={[
          {
            name: "MAT 2Y",
            data: [68, 51, 90, 11, 26, 95, 20, 65, 70, 30, 85, 80],
            color: "#6c5ce7",
            strokeDasharray: [5, 5]
          },
          {
            name: "MAT TY",
            data: [65, 59, 80, 81, 56, 55, 40, 45, 60, 70, 75, 80],
            color: "#007bff",
            strokeDasharray: [5, 5]
          },
          {
            name: "MAT LY",
            data: [28, 48, 40, 19, 86, 27, 90, 35, 40, 50, 60, 70],
            color: "#ff9500",
            strokeDasharray: [3, 3]
          }
        ]}
      />
      <WaterFallChart
        chartId="waterfallChart"
        chartClass="chart-container"
        chartLabels={[
          "Net revenue",
          "Cost of sales",
          "Operating expenses",
          "Amortisation",
          "Income from equity",
          "Operating income"
        ]}
        chartData={[8786, -2786, -1786, -453, 1465, 0]}
      />
      <HeatRiskGrowth
        chartId="heatRiskGrowthChart"
        chartClass="chart-container"
        yAxisLabels={yAxisLabels}
        xAxisLabels={xAxisLabels}
        data={HeatMapdata}
      />


      <HorizontalClusteredBarChart
        chartId="sales-chart"
        chartClass="chart-container"
        chartData={[
          { label: "MARICO", value1: 10000.5, value2: 18.1, value3: 5.4 },
          { label: "DABUR", value1: 26.2, value2: 22.8, value3: 3.4 },
          { label: "KLF", value1: 30.1, value2: 1223.9, value3: 6.2 },
          { label: "EMAMI", value1: 29.5, value2: 25.1, value3: 4.4 },
          { label: "EDIBLE", value1: 24.6, value2: 25, value3: 0.44 }
        ]}
        seriesConfig={[
          {
            name: "Sales Value",
            field: "value1",
            unit: "$",
            axisId: "primary"
          },
          {
            name: "Sales Volume",
            field: "value2",
            unit: "",
            axisId: "primary"
          },
          {
            name: "Premium Index",
            field: "value3",
            unit: "",
            axisId: "secondary",
          }
        ]}
      />
      <BarChart
        chartClass="section_card_chart"
        chartData={[
          {
            label: '2025-02-03',
            value: 1587,
            value2: 1000,
            value3: 500,
          },
          {
            label: '2025-02-04',
            value: 1567,
            value2: 1000,
            value3: 500,
          },
          {
            label: '2025-02-05',
            value: 1617,
            value2: 1000,
            value3: 500,
          },
          {
            label: '2025-02-06',
            value: 1630,
            value2: 1000,
            value3: 500,
          },
          {
            label: '2025-02-07',
            value: 1660,
            value2: 1000,
            value3: -500,
          },
          {
            label: '2025-02-08',
            value: 1683,
            value2: 1000,
            value3: -500,
          },
          {
            label: '2025-02-09',
            value: 1691,
            value2: -1000,
            value3: 500,
          }
        ]}
        chartId="storybookChart10.9209717029712361"
        chartLabels={[
          {
            label: 'Metric Name',
            value: 'value'
          },
          {
            label: 'label 2',
            value: 'value2'
          },
          {
            label: 'label 3',
            value: 'value3'
          },

        ]}
      />
      <GroupedBarChart chartId={GroupedBarChart + Math.random()} chartData={{
        "data": [
          {
            "label": "MAT 2Y",
            "Hair Conditioners": 725,
            "Hair Styling": 283,
            "Loreal": 271,
            "Unilever": 521,
            "Total": 1800
          },
          {
            "label": "MAT LY",
            "Hair Conditioners": 578,
            "Hair Styling": 321,
            "Loreal": -321,
            "Unilever": 521,
            "Total": 1099
          },
          {
            "label": "MAT TY",
            "Hair Conditioners": 821,
            "Hair Styling": 725,
            "Loreal": 321,
            "Unilever": 521,
            "Total": 2388
          }
        ],
        "label": [
          {
            "label": "Metric Name",
            "value": "Hair Conditioners"
          },
          {
            "label": "Metric Name",
            "value": "Hair Styling"
          },
          {
            "label": "Metric Name",
            "value": "Loreal"
          },
          {
            "label": "Metric Name",
            "value": "Unilever"
          },
          {
            "label": "Metric Name",
            "value": "Total"
          }
        ]
      }
      } />


      <CustomBarChart
        dropdownValue1="Sales Value"
        dropdownValue2="PPV"
        chartClass="section_card_chart"
        chartData={[
          {
            label: "Dabur",
            MAT2Y: 3200,
            MATLY: 3000,
            MATTY: 3500,
            // Ensure child keys match those in childData arrays below
            ppv_MAT2Y: 150,
            child2: 200,
            child3: 50,
          },
          {
            label: "Macro",
            MAT2Y: 2800,
            MATLY: 2700,
            MATTY: 2900,
            ppv_MAT2Y: 120,
            child2: 180,
            child3: 80,
          },
          {
            label: "Himalaya",
            MAT2Y: 3100,
            MATLY: 2950,
            MATTY: 3250,
            child1: 140,
            child2: 160,
            child3: 90,
          },
          {
            label: "Patanjali",
            MAT2Y: 3300,
            MATLY: 3100,
            MATTY: 3400,
            child1: 130,
            child2: 210,
            child3: 70,
          },
        ]}
        chartId="storybookChart10.9782892936524465"
        chartLabels={[
          {
            label: "MAT 2Y",
            value: "MAT2Y",
            parents: ["Sales Value", "PPV"],
            childData: [
              { label: "MAT 2Y", value: "ppv_MAT2Y" },
              { label: "Child 2", value: "child2" },
              { label: "Child 3", value: "child3" },
            ],
          },
          {
            label: "MAT LY",
            value: "MATLY",
            parents: ["Sales Value", "PPV"],
            childData: [
              { label: "MAT 2Y", value: "ppv_MAT2Y" },
              { label: "Child 2", value: "child2" },
              { label: "Child 3", value: "child3" },
            ],
          },
          {
            label: "MAT TY",
            value: "MATTY",
            parents: ["Sales Value", "PPV"],
            childData: [
              { label: "Child 1", value: "child1" },
              { label: "Child 2", value: "child2" },
              { label: "Child 3", value: "child3" },
            ],
          },
        ]}

      />
      <BarChart
        chartClass="section_card_chart"
        chartData={[
          {
            label: '2025-03-21',
            value1: 1587,
            value2: 1354,
            value3: 121,
            value4: 785,
            value5: 685,
            value6: 585
          },
          {
            label: '2025-03-22',
            value1: 1567,
            value2: 1423,
            value3: 146,
            value4: 182,
            value5: 282,
            value6: 382
          },
          {
            label: '2025-03-23',
            value1: 1617,
            value2: 1517,
            value3: 138,
            value4: 185,
            value5: 285,
            value6: 385
          },
          {
            label: '2025-03-24',
            value1: 1630,
            value2: 1530,
            value3: 127,
            value4: 145,
            value5: 245,
            value6: 345
          },
          {
            label: '2025-03-25',
            value1: 1660,
            value2: 1560,
            value3: 105,
            value4: 145,
            value5: 245,
            value6: 345
          },
          {
            label: '2025-03-26',
            value1: 1683,
            value2: 1683,
            value3: 109,
            value4: 185,
            value5: 285,
            value6: 385
          },
          {
            label: '2025-03-27',
            value1: 1691,
            value2: 1692,
            value3: 112,
            value4: 1250,
            value5: 2250,
            value6: 3250
          }
        ]}
        chartId="storybookChart10.5893301508634559"
        chartLabels={[
          {
            childLabel: 'Extra Metric Name 1',
            childValue: 'value2',
            label: 'Metric Name',
            value: 'value1'
          },
          {
            childLabel: 'Extra Metric Name 2',
            childValue: 'value4',
            label: 'Metric Name 2',
            value: 'value3'
          },
          {
            childLabel: 'Extra Metric Name 3',
            childValue: 'value6',
            label: 'Metric Name 3',
            value: 'value5'
          }
        ]}
      />


    </Wrapper>
  );
}
export default DashboardTest;
